import { render } from "./MovieCard.vue?vue&type=template&id=13cefd02&scoped=true"
import script from "./MovieCard.vue?vue&type=script&lang=js"
export * from "./MovieCard.vue?vue&type=script&lang=js"

import "./MovieCard.vue?vue&type=style&index=0&id=13cefd02&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cefd02"]])

export default __exports__